(() => {
  const normalize = (text) =>
    (text || '')
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();

  const getMediaId = (thumbnail) => {
    const target = thumbnail?.dataset?.target || '';
    const match = target.match(/(\d+)$/);
    return match ? match[1] : null;
  };

  const getProductUrl = (productInfo) => {
    const url = productInfo?.dataset?.url || window.location.pathname;
    return url.split('?')[0].replace(/\/$/, '') + '.js';
  };

  const productCache = new Map();

  const getProductData = async (productInfo) => {
    const url = getProductUrl(productInfo);
    if (productCache.has(url)) return productCache.get(url);

    const response = await fetch(url);
    if (!response.ok) return null;

    const product = await response.json();
    productCache.set(url, product);
    return product;
  };

  const getCurrentOptions = (productInfo) => {
    const options = [];
    const variantSelects = productInfo.querySelector('variant-selects') || productInfo;

    variantSelects.querySelectorAll('fieldset').forEach((fieldset) => {
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      options.push(checked ? checked.value : '');
    });

    variantSelects.querySelectorAll('select').forEach((select) => {
      options.push(select.value);
    });

    return options;
  };

  const selectVariant = (productInfo, variant) => {
    const variantSelects = productInfo.querySelector('variant-selects') || productInfo;

    variant.options.forEach((optionValue, index) => {
      const fieldset = variantSelects.querySelectorAll('fieldset')[index];

      if (fieldset) {
        const radios = fieldset.querySelectorAll('input[type="radio"]');

        for (const radio of radios) {
          const label = variantSelects.querySelector(`label[for="${radio.id}"]`);
          const radioText = normalize(radio.value);
          const labelText = normalize(label ? label.textContent : '');
          const wantedText = normalize(optionValue);

          if (radioText === wantedText || labelText === wantedText) {
            radio.click();
            return;
          }
        }
      }

      const select = variantSelects.querySelectorAll('select')[index];

      if (select) {
        for (const option of select.options) {
          if (normalize(option.value) === normalize(optionValue) || normalize(option.textContent) === normalize(optionValue)) {
            select.value = option.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
        }
      }
    });
  };

  const findBestVariant = (product, mediaId, currentOptions) => {
    const variants = product.variants.filter((variant) => {
      return variant.featured_media && String(variant.featured_media.id) === String(mediaId);
    });

    if (!variants.length) return null;

    return variants
      .map((variant) => {
        const score = variant.options.reduce((total, option, index) => {
          return total + (normalize(option) === normalize(currentOptions[index]) ? 1 : 0);
        }, 0);

        return { variant, score };
      })
      .sort((a, b) => {
        if (a.variant.available !== b.variant.available) return a.variant.available ? -1 : 1;
        return b.score - a.score;
      })[0].variant;
  };

  document.addEventListener('click', async (event) => {
    const gallery = event.target.closest('media-gallery');
    if (!gallery) return;

    const thumbnail = event.target.closest('[data-target]');
    if (!thumbnail) return;

    const mediaId = getMediaId(thumbnail);
    if (!mediaId) return;

    const productInfo = document.querySelector('product-info');
    if (!productInfo) return;

    const product = await getProductData(productInfo);
    if (!product) return;

    const currentOptions = getCurrentOptions(productInfo);
    const variant = findBestVariant(product, mediaId, currentOptions);

    if (!variant) return;

    window.setTimeout(() => {
      selectVariant(productInfo, variant);
    }, 50);
  });
})();